module.exports = __webpack_public_path__ + "img/default-cover.d1228850.png";